import PubSub from "underpub-js";

var HighlightHeadline = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-HighlightHeadline',
	};

	$.extend(true, this.options, options);

};

HighlightHeadline.prototype.init = function() {

	var self = this;

};

export default HighlightHeadline;
